import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { InternalFieldName } from 'react-hook-form/dist/types/fields';
import CustomButton from '../CustomButton/CustomButton';

export interface EquipmentFormFields {
  name: string;
  brand: string;
  model: string;
  serialNumber: string;
  description?: string;
}

interface EquipmentFormProps {
  isLoading: boolean;
  formFields: EquipmentFormFields;
  formErrors: Record<string, any>;
  onSubmit: (data: any) => void;
}

function addServerErrors<T>(
  errors: { [P in keyof T]?: string[] },
  setError: any
) {
  return Object.keys(errors).forEach((key) => {
    setError(key as keyof T, {
      type: 'server',
      message: errors[key as keyof T]!.join('. '),
    });
  });
}

export default function EquipmentForm({
  isLoading,
  formFields,
  formErrors,
  onSubmit,
}: EquipmentFormProps) {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
    reset,
  } = useForm<EquipmentFormFields>({ mode: 'onBlur' });

  useEffect(() => {
    reset(formFields);
  }, [formFields]);

  useEffect(() => {
    let shouldFocus = true;
    Object.keys(formErrors || {}).forEach((field: InternalFieldName) => {
      addServerErrors(formErrors, setError);

      shouldFocus = false;
    });
  }, [formErrors]);

  return (
    <form>
      <div className='mb-3'>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label htmlFor='inputLabel' className='form-label'>
          Nome
        </label>
        <input
          {...register('name', { required: true })}
          className='form-control'
          placeholder='Nome'
          type='text'
          required
        />
        {errors.name && (
          <div className='form-text text-danger'>{errors.name.message}</div>
        )}
      </div>
      <div className='mb-3'>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label htmlFor='inputLabel' className='form-label'>
          Marca
        </label>
        <input
          {...register('brand', { required: true })}
          className='form-control'
          placeholder='Marca'
          type='text'
          required
        />
        {errors.brand && (
          <div className='form-text text-danger'>{errors.brand.message}</div>
        )}
      </div>
      <div className='mb-3'>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label htmlFor='inputLabel' className='form-label'>
          Modelo
        </label>
        <input
          {...register('model', { required: true })}
          className='form-control'
          placeholder='Modelo'
          type='text'
          required
        />
        {errors.model && (
          <div className='form-text text-danger'>{errors.model.message}</div>
        )}
      </div>
      <div className='mb-3'>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label htmlFor='inputLabel' className='form-label'>
          Número de série
        </label>
        <input
          {...register('serialNumber', { required: true })}
          className='form-control'
          placeholder='Número de série'
          type='text'
          required
        />
        {errors.serialNumber && (
          <div className='form-text text-danger'>
            {errors.serialNumber.message}
          </div>
        )}
      </div>
      <div className='mb-3'>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label htmlFor='inputLabel' className='form-label'>
          Observações
        </label>
        <textarea
          {...register('description')}
          className='form-control'
          placeholder='Observações'
        />
        {errors.description && (
          <div className='form-text text-danger'>
            {errors.description.message}
          </div>
        )}
      </div>

      <div className='d-flex justify-content-end gap-2'>
        <CustomButton
          type='button'
          className='btn btn-primary'
          handleClick={handleSubmit(onSubmit)}
        >
          Salvar
        </CustomButton>
      </div>
    </form>
  );
}
